var styles = {"root":"CurrentMonth_root__JUjQs"};

export default styles;
